import React, { useState } from "react";
import { MdChatBubble } from "react-icons/md";
import { defaultChatBotSettings } from "../../consts/settings";

export default function ChatLauncher({ settings, onOpen }) {
  const [failedLogos, setFailedLogos] = useState([]);
  const logo = [settings.logo, defaultChatBotSettings.logo].find(source => source && !failedLogos.includes(source));
  return (
    <button type="button" aria-label="Open chat" onClick={onOpen} className="chat-launcher"
      style={{ backgroundColor: settings.headerBackgroundColor || defaultChatBotSettings.headerBackgroundColor, color: "#ffffff" }}>
      {logo ? (
        <span className="chat-launcher-logo">
          <img src={logo} alt="Assistant logo" draggable={false} onError={() => setFailedLogos(current => [...current, logo])} />
        </span>
      ) : <MdChatBubble size={28} aria-hidden="true" style={{ fill: "currentColor" }} />}
    </button>
  );
}
